import $ from 'jquery';
import screenSize from '../common/screen_size_util';

class NavSearch {
    constructor() {}
    on() {
        this.$navSearch = $('.nav-search');
        this.$search = $('.search-icon');
        this.$navSearchInput = $('.nav-search-input');
        this.$navSearchForm = $('.nav-search-form');
        this.$brandLogo = $('.nav-bar .left.brands .article-logo-topic.show-for-small');
        this.searchClick = this.searchClick.bind(this);
        this.submitListener = this.submitListener.bind(this);
        this.$search.on('click', this.searchClick);
        this.$navSearchForm.on('submit', this.submitListener);
    }
    submitListener() {
        const query = this.$navSearchInput.val();
        window.ga(
            'send',
            'event',
            'SEARCH_QUERY',
            query);
        return this;
    }
    searchClick() {
        this.$navSearch.toggleClass('open');
        this.$navSearchInput.focus();
        if (screenSize.getSize() === 'small') {
            // Hide navbar logo when search box is open
            if (this.$navSearch.hasClass('open')) {
                this.$brandLogo.removeClass('show-for-small').addClass('hide');
            } else {
                this.$brandLogo.removeClass('hide').addClass('show-for-small');
            }
        }
    }
    off() {
        this.$search.off('click', this.searchClick);
        this.$navSearchForm.off('submit', this.submitListener);
    }
}

export default new NavSearch();
